import type { ContentTemplate } from "building-types/views/planSets";
import { snakeCaseToTitleCase } from "common/utils/strings";

const CONTENT_TEMPLATE_NAME_SUFFIX = " Template";

export function contentTemplateDefaultBaseName(props: Partial<ContentTemplate>) {
  if (props?.templateType === "SHEET") {
    return "Sheet Template";
  }
  if (props?.templateType === "DRAWING" && props.drawingType === "ANNOTATION") {
    return "Annotation Drawing Template";
  }
  if (props?.templateType === "DRAWING" && !!props.drawingType) {
    return snakeCaseToTitleCase(props.drawingType) + CONTENT_TEMPLATE_NAME_SUFFIX;
  }

  return "Drawing Template";
}
